import { Epic, ofType } from "redux-observable";
import { RootState } from "../../store";
import * as authSelectors from "../auth/authSelectors";
import * as emailTemplateActions from "./emailTemplateActions";
import { ServiceContainer } from "../../serviceContainer";
import { AjaxError } from "rxjs/ajax";
import { catchError, exhaustMap, map, tap } from "rxjs/operators";
import { of } from "rxjs";

export const emailTemplateListEpic: Epic<
  any,
  any,
  RootState,
  ServiceContainer
> = (action$, state$, services) =>
  action$.pipe(
    ofType(emailTemplateActions.GET_EMAIL_TEMPLATES),
    exhaustMap((action: emailTemplateActions.GetEmailTemplatesAction) => {
      const state = state$.value;

      return services.apiEmailTemplate
        .listAll(
          authSelectors.accessToken(state),
          authSelectors.selectedOrganizationKeyName(state)
        )
        .pipe(
          map((x) =>
            emailTemplateActions.getEmailTemplatesSuccessAction(
              action.organization,
              x.data.items
            )
          ),
          catchError((error) => {
            return of(
              emailTemplateActions.getEmailTemplatesFailAction(
                action.organization
              )
            );
          })
        );
    })
  );

export const sendTestEmailTemplateEpic: Epic<
  any,
  any,
  RootState,
  ServiceContainer
> = (action$, state$, services) =>
  action$.pipe(
    ofType(emailTemplateActions.SEND_TEST_EMAIL_TEMPLATE),
    exhaustMap((action: emailTemplateActions.SendTestEmailTemplateAction) => {
      const state = state$.value;

      return services.apiEmailTemplate
        .sendTest(
          authSelectors.accessToken(state),
          action.organization,
          action.data
        )
        .pipe(
          tap(() =>
            services.toastr.success(
              "Send test",
              "Test email was sent successfully"
            )
          ),
          map(() =>
            emailTemplateActions.sendTestEmailTemplateSuccessAction(
              action.organization
            )
          ),
          catchError((x: AjaxError) => {
            services.toastr.error(
              "Error sending test email",
              "An error happened while sending test email"
            );
            return of(
              emailTemplateActions.sendTestEmailTemplateFailAction(
                action.organization
              )
            );
          })
        );
    })
  );
